// Offline Queue — IndexedDB store for sign-in/out actions when offline
const DB_NAME = "totocare_offline";
const STORE   = "queue";
const VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = e => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    };
    req.onsuccess = e => resolve(e.target.result);
    req.onerror   = e => reject(e.target.error);
  });
}

export const enqueue = async (action) => {
  const db   = await openDB();
  const item = { ...action, id: `${Date.now()}-${Math.random()}`, status: "pending" };
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE, "readwrite");
    const req = tx.objectStore(STORE).add(item);
    req.onsuccess = () => resolve(item);
    req.onerror   = e => reject(e.target.error);
  });
};

export const getPending = async () => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = e => resolve(e.target.result.filter(i => i.status === "pending"));
    req.onerror   = e => reject(e.target.error);
  });
};

export const removeItem = async (id) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx  = db.transaction(STORE, "readwrite");
    const req = tx.objectStore(STORE).delete(id);
    req.onsuccess = () => resolve();
    req.onerror   = e => reject(e.target.error);
  });
};
